import React, { useState } from "react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";

import  "./index.css";
import { set } from "lodash";

const PersianDatePicker = React.forwardRef(({placeholder="",  slash= false}, ref) => {
  function handleChange(value){
    
    
    const month=value.month.number<10?"0"+value.month.number:value.month.number;
    const day = value.day<10?"0"+value.day: value.day
    if(slash){
      ref.current=value.year+"/"+month+"/"+day;
    }else{
      ref.current=value.year+""+month+""+day;
    }
    
  }

  return (
    <div className="PersiandatePicker">
      <DatePicker
        format="YYYY/MM/DD"
        calendar={persian}
        locale={persian_fa}
        onChange={handleChange}
        placeholder={placeholder}
      />
    </div>
  );
});

export default PersianDatePicker;
